import { NavLink } from "react-router-dom";

export function NotFound() {
    return (
        <div>
            <h2>Данной страницы не существует. <NavLink to="/">Вернуться на главную</NavLink></h2>
        </div>
    )
}
